var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 65,
    viewBox: "0 0 86 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8863 65.0001C54.5942 64.8364 49.5737 62.6191 45.8882 58.8178C42.2026 55.0166 40.1416 49.9299 40.1416 44.6353C40.1416 39.3407 42.2026 34.254 45.8882 30.4527C49.5737 26.6515 54.5942 24.4341 59.8863 24.2705C60.0209 24.2679 60.1547 24.2921 60.2798 24.3419C60.405 24.3916 60.519 24.4658 60.6151 24.5601C60.7112 24.6545 60.7875 24.767 60.8397 24.8912C60.8918 25.0154 60.9186 25.1487 60.9186 25.2833V43.6127H79.2284C79.5022 43.6127 79.7648 43.7214 79.9584 43.915C80.152 44.1086 80.2609 44.3712 80.2609 44.645C80.2506 50.0437 78.1 55.2181 74.2807 59.0337C70.4614 62.8494 65.285 64.995 59.8863 65.0001ZM58.8734 26.3352C54.1999 26.6082 49.8071 28.6554 46.5923 32.0584C43.3775 35.4615 41.5834 39.9636 41.5764 44.645C41.5266 49.4461 43.3644 54.0746 46.6942 57.5336C50.024 60.9926 54.5793 63.0053 59.3788 63.1381C64.1782 63.2709 68.8378 61.5132 72.3538 58.2437C75.8698 54.9741 77.9609 50.4544 78.1766 45.6579H59.8863C59.6176 45.6579 59.36 45.5512 59.17 45.3612C58.9801 45.1713 58.8734 44.9137 58.8734 44.645V26.3352Z",
    fill: "url(#paint0_linear_87_112)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3328 40.5545H64.9906C64.7219 40.5545 64.4643 40.4477 64.2744 40.2578C64.0844 40.0678 63.9777 39.8102 63.9777 39.5416V20.1994C63.9751 20.0647 63.9994 19.9309 64.0492 19.8058C64.0989 19.6806 64.1731 19.5666 64.2674 19.4705C64.3617 19.3744 64.4742 19.298 64.5984 19.2459C64.7226 19.1938 64.8559 19.167 64.9906 19.167C67.6669 19.1644 70.3175 19.6897 72.7906 20.7127C75.2637 21.7357 77.5108 23.2364 79.4033 25.1289C81.2957 27.0213 82.7964 29.2684 83.8194 31.7415C84.8424 34.2146 85.3677 36.8652 85.3651 39.5416C85.3652 39.6762 85.3383 39.8096 85.2862 39.9337C85.2341 40.0579 85.1578 40.1704 85.0616 40.2648C84.9655 40.3591 84.8515 40.4333 84.7264 40.483C84.6012 40.5328 84.4675 40.557 84.3328 40.5545ZM66.023 38.5092H83.281C83.0252 34.0154 81.1248 29.7728 77.9421 26.5901C74.7593 23.4074 70.5168 21.507 66.023 21.2512V38.5092Z",
    fill: "url(#paint1_linear_87_112)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9995 56.5657H7.58689C5.57731 56.5657 3.65005 55.7674 2.22905 54.3464C0.80806 52.9254 0.00975303 50.9981 0.00975303 48.9885V18.9331C-0.010463 18.787 0.000818691 18.6382 0.0429465 18.4968C0.0850743 18.3555 0.156997 18.2247 0.253901 18.1135C0.350805 18.0023 0.470488 17.9131 0.604762 17.852C0.739036 17.7909 0.884854 17.7593 1.03238 17.7593C1.1799 17.7593 1.32572 17.7909 1.45999 17.852C1.59427 17.9131 1.71385 18.0023 1.81076 18.1135C1.90766 18.2247 1.97959 18.3555 2.02171 18.4968C2.06384 18.6382 2.07522 18.787 2.055 18.9331V48.9885C2.055 49.715 2.19805 50.4343 2.47605 51.1055C2.75406 51.7767 3.16152 52.3865 3.6752 52.9002C4.18889 53.4139 4.79877 53.8213 5.46993 54.0993C6.14109 54.3773 6.86043 54.5204 7.58689 54.5204H36.9995C37.1342 54.5204 37.2675 54.5472 37.3917 54.5994C37.5158 54.6515 37.6284 54.7278 37.7227 54.824C37.817 54.9201 37.8912 55.0341 37.9409 55.1592C37.9907 55.2843 38.0149 55.4182 38.0123 55.5528C38.0123 55.8214 37.9057 56.0791 37.7157 56.269C37.5257 56.459 37.2682 56.5657 36.9995 56.5657Z",
    fill: "url(#paint2_linear_87_112)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9952 15.7387C69.8605 15.7387 69.7272 15.7119 69.6031 15.6598C69.4789 15.6076 69.3663 15.5313 69.272 15.4352C69.1777 15.339 69.1036 15.2251 69.0538 15.0999C69.0041 14.9748 68.9797 14.841 68.9823 14.7063V7.57716C68.9823 6.11001 68.3995 4.70294 67.3621 3.66551C66.3247 2.62808 64.9176 2.04525 63.4504 2.04525H7.58593C6.11878 2.04525 4.71167 2.62808 3.67424 3.66551C2.6368 4.70294 2.05404 6.11001 2.05404 7.57716V9.27179C2.05404 9.50426 2.14636 9.72722 2.31074 9.8916C2.47512 10.056 2.6981 10.1483 2.93057 10.1483H55.9123C56.0584 10.1281 56.2071 10.1395 56.3485 10.1816C56.4899 10.2237 56.6206 10.2957 56.7318 10.3926C56.8431 10.4895 56.9323 10.6091 56.9934 10.7433C57.0545 10.8776 57.086 11.0234 57.086 11.1709C57.086 11.3185 57.0545 11.4643 56.9934 11.5986C56.9323 11.7328 56.8431 11.8525 56.7318 11.9494C56.6206 12.0463 56.4899 12.1182 56.3485 12.1603C56.2071 12.2025 56.0584 12.2138 55.9123 12.1936H2.93057C2.15567 12.1936 1.41244 11.8857 0.864495 11.3378C0.316554 10.7899 0.00878906 10.0467 0.00878906 9.27179V7.57716C0.0139312 5.56916 0.813821 3.64486 2.2337 2.22498C3.65358 0.805103 5.57792 0.00514217 7.58593 0H63.4504C65.4584 0.00514217 67.3828 0.805103 68.8026 2.22498C70.2225 3.64486 71.0224 5.56916 71.0275 7.57716V14.7063C71.0275 14.9801 70.9188 15.2427 70.7252 15.4363C70.5316 15.6299 70.269 15.7387 69.9952 15.7387Z",
    fill: "url(#paint3_linear_87_112)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10678 7.46291C8.96783 7.10727 9.37749 6.12097 9.02184 5.25992C8.66619 4.39887 7.67991 3.98914 6.81886 4.34479C5.95782 4.70044 5.54808 5.68679 5.90373 6.54784C6.25938 7.40888 7.24574 7.81856 8.10678 7.46291Z",
    fill: "url(#paint4_linear_87_112)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6378 7.21029C16.2996 6.54849 16.2996 5.47549 15.6378 4.81369C14.976 4.15189 13.903 4.15192 13.2412 4.81372C12.5794 5.47551 12.5795 6.54846 13.2413 7.21025C13.9031 7.87205 14.976 7.87208 15.6378 7.21029Z",
    fill: "url(#paint5_linear_87_112)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.78 6.51378C22.9953 5.60296 22.4315 4.69002 21.5207 4.47471C20.6099 4.2594 19.697 4.82326 19.4817 5.73408C19.2663 6.6449 19.8302 7.55784 20.741 7.77315C21.6518 7.98846 22.5647 7.4246 22.78 6.51378Z",
    fill: "url(#paint6_linear_87_112)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3165 21.2122H30.4946C30.2259 21.2122 29.9682 21.1055 29.7783 20.9156C29.5883 20.7256 29.4816 20.468 29.4816 20.1994C29.479 20.0647 29.5033 19.9309 29.5531 19.8058C29.6028 19.6806 29.677 19.5666 29.7713 19.4705C29.8657 19.3744 29.9781 19.298 30.1023 19.2459C30.2265 19.1938 30.3599 19.167 30.4946 19.167H57.3165C57.452 19.167 57.5863 19.1937 57.7116 19.2456C57.8368 19.2975 57.9506 19.3735 58.0464 19.4694C58.1423 19.5652 58.2184 19.679 58.2702 19.8043C58.3221 19.9295 58.3489 20.0638 58.3489 20.1994C58.3489 20.334 58.3221 20.4673 58.27 20.5915C58.2178 20.7157 58.1414 20.8282 58.0453 20.9225C57.9492 21.0169 57.8353 21.0911 57.7101 21.1408C57.585 21.1905 57.4511 21.2148 57.3165 21.2122Z",
    fill: "url(#paint7_linear_87_112)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6117 21.2122H13.7229C13.5882 21.2148 13.4543 21.1905 13.3292 21.1408C13.204 21.0911 13.0901 21.0169 12.994 20.9225C12.8979 20.8282 12.8215 20.7157 12.7694 20.5915C12.7173 20.4673 12.6904 20.334 12.6904 20.1994C12.6904 19.9256 12.7993 19.663 12.9929 19.4694C13.1865 19.2758 13.4491 19.167 13.7229 19.167H21.6117C21.8855 19.167 22.148 19.2758 22.3416 19.4694C22.5352 19.663 22.644 19.9256 22.644 20.1994C22.644 20.334 22.6172 20.4673 22.5651 20.5915C22.5129 20.7157 22.4366 20.8282 22.3405 20.9225C22.2444 21.0169 22.1304 21.0911 22.0052 21.1408C21.8801 21.1905 21.7463 21.2148 21.6117 21.2122Z",
    fill: "url(#paint8_linear_87_112)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6488 29.7049H13.7229C13.5882 29.7075 13.4543 29.6832 13.3292 29.6335C13.204 29.5837 13.0901 29.5095 12.994 29.4152C12.8979 29.3209 12.8215 29.2084 12.7694 29.0842C12.7173 28.96 12.6904 28.8267 12.6904 28.692C12.6904 28.4182 12.7993 28.1556 12.9929 27.962C13.1865 27.7684 13.4491 27.6597 13.7229 27.6597H39.6488C39.7844 27.6597 39.9186 27.6864 40.0438 27.7383C40.1691 27.7901 40.2829 27.8662 40.3788 27.962C40.4747 28.0579 40.5507 28.1717 40.6026 28.297C40.6545 28.4222 40.6812 28.5565 40.6812 28.692C40.6812 28.8267 40.6543 28.96 40.6022 29.0842C40.5501 29.2084 40.4738 29.3209 40.3777 29.4152C40.2815 29.5095 40.1675 29.5837 40.0424 29.6335C39.9172 29.6832 39.7835 29.7075 39.6488 29.7049Z",
    fill: "url(#paint9_linear_87_112)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5972 38.1976H13.7229C13.5882 38.2002 13.4543 38.1759 13.3292 38.1262C13.204 38.0764 13.0901 38.0022 12.994 37.9079C12.8979 37.8136 12.8215 37.7011 12.7694 37.5769C12.7173 37.4527 12.6904 37.3194 12.6904 37.1847C12.6904 36.9109 12.7993 36.6483 12.9929 36.4547C13.1865 36.2611 13.4491 36.1523 13.7229 36.1523H35.5972C35.7319 36.1523 35.8652 36.1792 35.9894 36.2313C36.1135 36.2834 36.2261 36.3597 36.3204 36.4559C36.4148 36.552 36.489 36.666 36.5387 36.7911C36.5885 36.9163 36.6127 37.0501 36.6102 37.1847C36.6102 37.3177 36.5839 37.4494 36.533 37.5723C36.4821 37.6952 36.4076 37.8069 36.3135 37.9009C36.2195 37.995 36.1078 38.0696 35.9849 38.1205C35.862 38.1714 35.7302 38.1976 35.5972 38.1976Z",
    fill: "url(#paint10_linear_87_112)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9545 46.69H13.7229C13.5882 46.6926 13.4543 46.6683 13.3292 46.6186C13.204 46.5688 13.0901 46.4946 12.994 46.4003C12.8979 46.306 12.8215 46.1935 12.7694 46.0693C12.7173 45.9451 12.6904 45.8118 12.6904 45.6771C12.6904 45.4033 12.7993 45.1407 12.9929 44.9471C13.1865 44.7535 13.4491 44.6448 13.7229 44.6448H34.9545C35.0891 44.6448 35.2224 44.6716 35.3466 44.7237C35.4708 44.7758 35.5834 44.8522 35.6777 44.9483C35.772 45.0444 35.8461 45.1584 35.8959 45.2835C35.9456 45.4087 35.9699 45.5425 35.9673 45.6771C35.9673 45.9458 35.8606 46.2034 35.6707 46.3934C35.4807 46.5833 35.2231 46.69 34.9545 46.69Z",
    fill: "url(#paint11_linear_87_112)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_112",
    x1: 39.3058,
    y1: 22.7791,
    x2: 98.4951,
    y2: 44.6055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_112",
    x1: 63.532,
    y1: 18.3839,
    x2: 94.9704,
    y2: 30.1535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_112",
    x1: -0.791926,
    y1: 16.3385,
    x2: 55.3636,
    y2: 36.9313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_87_112",
    x1: -1.47077,
    y1: -0.576227,
    x2: 29.4148,
    y2: 51.5985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_87_112",
    x1: 5.14765,
    y1: 4.90144,
    x2: 10.4398,
    y2: 4.72417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_87_112",
    x1: 11.9053,
    y1: 5.97415,
    x2: 16.7469,
    y2: 3.77017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_87_112",
    x1: 18.9548,
    y1: 7.42347,
    x2: 21.9161,
    y2: 3.00409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_87_112",
    x1: 28.88,
    y1: 19.0921,
    x2: 30.5532,
    y2: 27.9323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_87_112",
    x1: 12.4831,
    y1: 19.0921,
    x2: 16.3456,
    y2: 26.1288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_87_112",
    x1: 12.1073,
    y1: 27.5848,
    x2: 13.8291,
    y2: 36.4056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_87_112",
    x1: 12.1921,
    y1: 36.0775,
    x2: 14.18,
    y2: 44.7803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_87_112",
    x1: 12.2055,
    y1: 44.5699,
    x2: 14.2426,
    y2: 53.2486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureImg2);
export default __webpack_public_path__ + "static/media/feature_img_2.bce46fb50c4c1253f7066193d3286c89.svg";
export { ForwardRef as ReactComponent };